module.exports = __webpack_public_path__ + "static/img/US.447e2bf0.svg";